import { createFileRoute } from "@tanstack/react-router";
import { useParams } from "@/lib/navigation";
import { InvestmentAdmin } from "@/components/Investments/Admin";

function RouteComponent() {
  const params = useParams();
  const investmentId = params?.id as string;

  return <InvestmentAdmin investmentId={investmentId} />;
}

export const Route = createFileRoute("/_authenticated/investments/$id/")({
  component: RouteComponent,
  staticData: { page: ["deals", "banking"] },
});
